//import $ from 'jquery';
import * as helpers from "./helpers.js";
import * as sliders from "./sliders.js";
import * as inviews from "./inviews.js";
import * as clicks from "./clicks.js";
/*import * as sliders from "./sliders.js";*/

$(document).ready(function() {
  var header = $("header");
  document.createElement("main");
  helpers.checkBrowsers();

  $(".block-accordion").each(function() {
    var elm = $(this);

    $(elm)
      .find(".block-accordion-elm")
      .eq(0)
      .find("a")
      .addClass("active")
      .next()
      .slideDown();

    $(elm)
      .find("a")
      .click(function(j) {
        if (!$(this).hasClass("active")) {
          $(".block-accordion-elm .active")
            .removeClass("active")
            .next()
            .slideUp();
          $(this)
            .addClass("active")
            .next()
            .slideDown();
        }
        j.preventDefault();
      });
  });

  //$(window).on('resize', function() {});
});
